import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CloseButton,
  Spinner,
} from 'reactstrap';
import { getEntityFilterConnectionsmeeting } from 'app/entities/connectionmeeting/connectionmeeting.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { createUserMeeting } from 'app/entities/meeting/meeting.reducer';

import Select, { components } from 'react-select';
import { default as ReactSelect } from 'react-select';
import makeAnimated from 'react-select/animated';
import { createEntityInterview } from 'app/entities/meetinginfo/meetinginfo.reducer';
import { getEntities } from 'app/entities/topic/topic.reducer'; // Add this import
import { ITopic } from 'app/shared/model/topic.model';
import axios from 'axios';

interface User {
  name: string;
  email: string;
  selected: boolean;
  userId: string;
  image: string;
  occupation: string;
}

interface InterviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  isInterview?: boolean; // Optional prop to force interview mode
}

const InterviewModal: React.FC<InterviewModalProps> = ({ isOpen, onClose, isInterview = false }) => {
  const [title, setTitle] = useState('');
  const [date, setDate] = useState('');
  const [duration, setDuration] = useState('');
  const [interviewLink, setInterviewLink] = useState('');
  const [users, setUsers] = useState<User[]>([]);
  const [titleError, setTitleError] = useState('');
  const [dateError, setDateError] = useState('');
  const [durationError, setDurationError] = useState('');
  const [linkError, setLinkError] = useState('');
  const [userError, setUserError] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [meetingType, setMeetingType] = useState(isInterview ? 'interview' : 'meeting');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const topics = useAppSelector(state => state.topic.entities);
  const dispatch = useAppDispatch();
  const connectionMeetingEntity = useAppSelector(state => state.connectionmeeting.entity);
  const account = useAppSelector(state => state.authentication.account);
  const [allTopics, setAllTopics] = useState([]);
  const SpecialCharacterRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~/\\]/;
  // const UrlRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
  // const UrlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-._~:/?#[\]@!$&'()+,;=])?$/;
  const UrlRegex = /https?:\/\/(?:www\.)?[a-zA-Z0-9\-_.]+(?:\.[a-zA-Z]{2,})(?:\/[^\s]*)?/g;

  const baseImageUrl = '/profile/get/image';
  const [mediaPreview, setMediaPreview] = useState('');
  const [imageName, setImageName] = useState(null);
  const [uploadedMedia, setUploadedMedia] = useState(null);
  const [error, setError] = useState('');

  const animatedComponents = makeAnimated();
  const [selectedTopicIds, setSelectedTopicIds] = useState<string[]>([]); // Track selected topic IDs
  const [selectedTopicOptions, setSelectedTopicOptions] = useState<any[]>([]);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showAllTopics, setShowAllTopics] = useState(false);

  const initialTopicsToShow = 25;

  useEffect(() => {
    dispatch(getEntityFilterConnectionsmeeting(['connection', 'accepted']));
    dispatch(getEntities({ page: 0, size: 100, sort: 'id,asc' }));
  }, []);

  useEffect(() => {
    if (Array.isArray(connectionMeetingEntity)) {
      const formattedUsers = connectionMeetingEntity?.map(connection => ({
        value: connection.userId,
        image: connection.imageUrl,
        label: connection.userName,
        name: connection.userName,
        email: connection.email,
        selected: false,
        userId: connection.userId,
        occupation: connection.occupation,
      }));
      setUsers(formattedUsers);
    }
  }, [connectionMeetingEntity]);

  const topicOptions = topics.map(topic => ({
    value: topic.id,
    label: topic.name,
  }));

  const handleTopicSelect = selected => {
    if (!selected) {
      setSelectedTopicOptions([]);
      return;
    }

    if (selected.length <= 10) {
      setSelectedTopicOptions(selected);
    }
  };

  const handleMeetingGuests = selected => {
    setUserError('');
    const selectedItems = selected.map(user => user.value);
    setSelectedUsers(selectedItems);
  };
  const handleTopicToggle = (topicId: string) => {
    setSelectedTopicIds(prev => (prev.includes(topicId) ? prev.filter(id => id !== topicId) : [...prev, topicId]));
  };
  const Option = props => {
    return (
      <div>
        <components.Option {...props}>
          <img src={`${baseImageUrl}/${props.data.image}`} width={30} height={30} className="rounded-circle" alt={props.label} />
          &nbsp;&nbsp;
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());

    return now.toISOString().slice(0, 16);
  };

  const currentDate = getCurrentDateTime();
  // const currentDate = new Date().toISOString().slice(0, 16);
  // const MAX_MEETING_DURATION_MS = 2 * 60 * 1000;
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setTitleError('');
    setDateError('');
    setUserError('');
    setLinkError('');
    setError('');

    // Validate title (only for meetings)
    // if (meetingType === 'meeting') {
    //   if (!title) {
    //     setTitleError('Please enter a title');
    //     return;
    //   }
    //   if (SpecialCharacterRegex.test(title)) {
    //     setTitleError('Special characters are not allowed');
    //     return;
    //   }
    // }

    // Validate date
    if (!date) {
      setDateError('Please enter a date');
      return;
    }

    // Validate that either link or video is provided
    if (!interviewLink && !uploadedMedia) {
      setLinkError('Please provide either a interview link or upload a video');
      setError('Please provide either a interview link or upload a video');
      return;
    }

    // If both are provided, that's fine too, but we just need at least one
    // Validate the link if provided
    if (interviewLink && !UrlRegex.test(interviewLink)) {
      setLinkError('Please enter a valid URL');
      return;
    }

    try {
      const selectedTopicIdsArray = selectedTopicOptions.map(opt => Number(opt.value));

      const formattedDatetime = new Date(date);
      const meetingData = {
        name: title,
        createdByUserId: account.id,
        dateTime: formattedDatetime.getTime(),
        meetingLink: interviewLink || null, // Send null if empty
        topicIds: selectedTopicIdsArray,
        attachmentsList: uploadedMedia ? [uploadedMedia] : [], // Empty array if no media
      };

      const resultAction = await dispatch(createEntityInterview(meetingData));

      if (createEntityInterview.fulfilled.match(resultAction)) {
        setFormSubmitted(true);
      } else if (createEntityInterview.rejected.match(resultAction)) {
        const error = resultAction.error;
        setUserError(error.message || 'Failed to create meeting');
      }
    } catch (error) {
      setUserError('An unexpected error occurred');
    }
  };
  const resetForm = () => {
    setTitle('');
    setDate('');
    setDuration('');
    setInterviewLink('');
    setSelectedUsers([]);
    setTitleError('');
    setDateError('');
    setLinkError('');
    setUserError('');
    setFormSubmitted(false);
    setMeetingType('interview');
  };

  const handleClose = () => {
    resetForm();
    setMediaPreview('');
    setSelectedTopicIds([]);
    setUploadedMedia(null);
    setImageName('');
    onClose();
  };
  const handleMediaFileInputChange = event => {
    const selectedFile = event.target.files[0];
    setError(''); // Clear previous errors
    setLinkError('');
    if (selectedFile) {
      // Validate file type
      // if (!selectedFile.type.startsWith('video/')) {
      //   setError('Please upload only video files');
      //   return;
      // }

      // Validate file size
      if (selectedFile.size > 50 * 1024 * 1024) {
        setError('File size should be less than 50MB');
        return;
      }

      setIsUploading(true); // Start loading
      const formData = new FormData();
      formData.append('image', selectedFile);

      const uploadUrl = selectedFile.type.startsWith('video/') ? '/api/upload?type=video' : '/api/upload/';

      axios
        .post(uploadUrl, formData)
        .then(response => {
          const fullMediaUrl = `${baseImageUrl}/${response.data}`;
          setMediaPreview(fullMediaUrl);
          setImageName(response.data);
          setUploadedMedia(response.data);
          setError('');
        })
        .catch(error => {
          setError('Error uploading video. Please try again.');
          console.error('Error uploading media:', error);
        })
        .finally(() => {
          setIsUploading(false); // Stop loading regardless of success/failure
        });
    }
  };
  const handleRemoveMedia = () => {
    setMediaPreview('');
    setUploadedMedia(null);
    setImageName('');
  };
  return (
    <Modal isOpen={isOpen} toggle={handleClose} size="lg" className="interview-modal">
      <ModalHeader toggle={handleClose}>{'Create New Interview'}</ModalHeader>
      <ModalBody>
        {!formSubmitted ? (
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="title">Topic of Discussion </Label>
              <Input
                type="text"
                id="title"
                value={title}
                onChange={e => setTitle(e.target.value)}
                onFocus={() => setTitleError('')}
                invalid={!!titleError}
                placeholder="Enter interview topic"
              />
              <FormFeedback>{titleError}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="date">
                Date <span className="text-danger">*</span>
              </Label>
              <Input
                type="datetime-local"
                id="date"
                min={currentDate}
                value={date}
                onChange={e => {
                  const selectedDate = e.target.value;
                  if (selectedDate < currentDate) {
                    setDateError('Past dates and times are not allowed.');
                    return;
                  }
                  setDate(selectedDate);
                }}
                onInput={() => setDateError('')}
                invalid={!!dateError}
              />
              {dateError && <FormFeedback>{dateError}</FormFeedback>}
            </FormGroup>

            {/* <FormGroup>
              <Label for="duration">Duration (in minutes)</Label>
              <Input
                type="number"
                id="duration"
                value={duration}
                onChange={e => setDuration(e.target.value)}
                onInput={() => setDurationError('')}
                invalid={!!durationError}
                required
              />
              {durationError && <FormFeedback>{durationError}</FormFeedback>}
            </FormGroup> */}
            {/* Add Topics Section */}
            {/* Topics Selection */}
            <FormGroup>
              <Label>
                Select Topics
                <span className="ms-2 text-muted">({selectedTopicOptions.length}/10 selected)</span>
              </Label>

              <Select
                options={topicOptions}
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                value={selectedTopicOptions}
                onChange={handleTopicSelect}
                placeholder="Select topics (max 10)..."
                isOptionDisabled={option => selectedTopicOptions.length >= 10 && !selectedTopicOptions.some(t => t.value === option.value)}
              />

              {selectedTopicOptions.length >= 10 && (
                <small className="text-info mt-1 d-block">You have selected the maximum of 10 topics.</small>
              )}
            </FormGroup>
            <FormGroup>
              <Label for="interviewLink">Interview Link</Label>
              <Input
                type="url"
                id="interviewLink"
                value={interviewLink}
                onChange={e => {
                  setInterviewLink(e.target.value);
                  setLinkError(''); // Clear error when typing
                }}
                invalid={!!linkError}
                placeholder="Enter link (e.g., https://meet.google.com/abc-xyz)"
              />
              <FormFeedback>{linkError}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="videoLink">Upload interview video</Label>
              <Input
                type="file"
                id="videoLink"
                onChange={handleMediaFileInputChange}
                accept="video/*"
                invalid={!!error}
                disabled={isUploading}
              />
              {isUploading && (
                <div className="mt-2">
                  <Spinner size="sm" color="primary" /> Uploading video...
                </div>
              )}
              {error && <div className="text-danger small mt-1">{error}</div>}
              {mediaPreview && (
                <div className="mt-2">
                  <video width="200" controls src={mediaPreview} className="img-thumbnail" />
                  <Button color="danger" size="sm" onClick={handleRemoveMedia} className="ms-2">
                    Remove
                  </Button>
                </div>
              )}
            </FormGroup>

            <ModalFooter className="mt-4">
              <Button color="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button type="submit" color="primary" disabled={isSubmitting}>
                {isSubmitting ? 'creating...' : 'Create'}
              </Button>
            </ModalFooter>
          </Form>
        ) : (
          <div className="alert alert-success text-center py-3">Interview scheduled successfully!</div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default InterviewModal;
